<template lang="pug">
  b-modal#addPromotionBanner(
  ref="addPromotionBanner"
  :title="$t('ui.combine.add_promotion_banner')"
  centered
  no-fade
  no-close-on-backdrop
  size="lg"
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row.mb-3
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.category')").mb-0
            PromotionCategoryLookup(
              ref="category"
              size="sm"
              required
              type="array"
              :dirty="$v.category.$dirty"
              :error="$v.category.$error"
              v-model.trim.lazy="$v.category.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.category" :name="$t('ui.category')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.default_order')").mb-2
            div.d-flex
              label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                input.switch-input(
                  type="checkbox"
                  required
                  :dirty="$v.default_order.$dirty"
                  :error="$v.default_order.$error"
                  v-model.trim.lazy="$v.default_order.$model"
                  :disabled="loading"
                )
                span.switch-slider(:data-checked='on' :data-unchecked='off')
            ValidateResult(:value="$v.default_order" :name="$t('ui.default_order')")
        div.col-sm-12.col-md-4.col-lg-4(v-if="default_order == false")
          b-form-group(:label="$t('ui.item_order')").mb-0
            CMSBannerCount(
              ref="item_order"
              size="sm"
              required
              type="array"
              :dirty="$v.item_order.$dirty"
              :error="$v.item_order.$error"
              v-model.trim.lazy="$v.item_order.$model"
              bType="promotion"
              :disabled="loading"
            )
            ValidateResult(:value="$v.item_order" :name="$t('ui.item_order')")
      b-tabs(small card)
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;").mr-1 {{ $t("ui.en") }}
            i.flag-icon.flag-icon-us
          div.d-flex.flex-wrap
            b-form-group.w-100(:label="$t('ui.title')").mb-0
              //- vue-editor(v-model="content")
              ckeditor(
                v-model="en_title"
                :config="enTitleConfig"
                :disabled="loading"
                )
              //- ckeditor(
              //-   :dirty="$v.en_title.$dirty"
              //-   :error="$v.en_title.$error"
              //-   v-model.trim.lazy="$v.en_title.$model"
              //-   :config="editorConfig"
              //-   :disabled="loading"
              //-   )
              //- ValidateResult(:value="$v.en_title" :name="$t('ui.en_title')")
            b-form-group.w-100(:label="$t('ui.body')").mb-0
              //- vue-editor(v-model="content")
              ckeditor(
                v-model="en_body"
                :config="enBodyConfig"
                :disabled="loading"
                )
              //- ckeditor(
              //-   :dirty="$v.en_body.$dirty"
              //-   :error="$v.en_body.$error"
              //-   v-model.trim.lazy="$v.en_body.$model"
              //-   :disabled="loading"
              //-   )
              //- ValidateResult(:value="$v.en_body" :name="$t('ui.en_body')")
            b-form-group.w-100(:label="$t('ui.image')").mb-0
              b-form-file(
                :dirty="$v.en_image.$dirty"
                :error="$v.en_image.$error"
                v-model.trim.lazy="$v.en_image.$model"
                ref="file"
                accept="image/jpeg, image/png, image/gif"
                @change="onSelectEn"
                v-if="enImageSrc == null"
              )
              ValidateResult(:value="$v.en_image" :name="$t('ui.en_image')")
              SubmitButton(
                :loading="loading"
                icon="fa fa-times"
                :text="$t('ui.remove')"
                type="button"
                @click="removeEnImage()"
                variant="danger"
                size="sm"
                v-if="enImageSrc != null"
                )
              br
              b-img.w-50.h-50(v-if="enImageSrc != null" :src="enImageSrc")
        b-tab(title-link-class="small-link" title-item-class="small-item")
          template(slot="title")
            span(style="padding: 1px; line-height: 16px;").mr-1 {{ $t("ui.fil") }}
            i.flag-icon.flag-icon-ph
          div.d-flex.flex-wrap
            b-form-group.w-100(:label="$t('ui.title')").mb-0
              //- vue-editor(v-model="content")
              ckeditor(
                v-model="fil_title"
                :config="filTitleConfig"
                :disabled="loading"
                )
            b-form-group.w-100(:label="$t('ui.body')").mb-0
              //- vue-editor(v-model="content")
              ckeditor(
                v-model="fil_body"
                :config="filBodyConfig"
                :disabled="loading"
                )
            b-form-group.w-100(:label="$t('ui.image')").mb-0
              b-form-file(
                :dirty="$v.fil_image.$dirty"
                :error="$v.fil_image.$error"
                v-model.trim.lazy="$v.fil_image.$model"
                ref="file"
                accept="image/jpeg, image/png, image/gif"
                @change="onSelectFil"
                v-if="filImageSrc == null"
              )
              ValidateResult(:value="$v.fil_image" :name="$t('ui.fil_image')")
              SubmitButton(
                :loading="loading"
                icon="fa fa-times"
                :text="$t('ui.remove')"
                type="button"
                @click="removeFilImage()"
                variant="danger"
                size="sm"
                v-if="filImageSrc != null"
                )
              br
              b-img.w-50.h-50(v-if="filImageSrc != null" :src="filImageSrc")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import CMSBannerCount from "@/library/CMSBannerCount";
import PromotionCategoryLookup from "@/library/PromotionCategoryLookup";
import { VueEditor, Quill } from "vue2-editor";
import $ from 'jquery';
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const fileSizeValidation = (value, vm) =>  {
  if (!value) {
    return true;
  }
  let file = value;
  return (file.size < 1000000);
};
const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    CMSBannerCount,
    VueEditor,
    PromotionCategoryLookup
  },
  props: {
    // item: {
    //   type: Object
    // },
  },
  data() {
    return {
      item_order: 0,
      default_order: true,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      en_title: "",
      en_body: "",
      en_image: null,
      fil_title: "",
      fil_body: "",
      fil_image: null,
      filTitleConfig: {
        versionCheck: false,
        height: '80px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      enTitleConfig: {
        versionCheck: false,
        height: '80px',
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      filBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      enBodyConfig: {
        versionCheck: false,
        format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div',
        extraPlugins: 'colorbutton,colordialog'
      },
      file: "",
      en_image_url: "",
      fil_image_url: "",
      enImageName: "",
      filImageName: "",
      enImageSrc: null,
      filImageSrc: null,
      category: "ALL",
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
  },
  validations: {
    category: {
      required
    },
    default_order: {
      required
    },
    item_order: {
      required : requiredIf(function () {
        return this.default_order == false;
      }),
      minValue(value) {
        if (this.default_order == true) {
          return minValue(0)(value)
        } else {
          return minValue(1)(value)
        }
      }
    },
    // en_title: {
    //   required
    // },
    // en_body: {
    //   required
    // },
    en_image: {
      required : requiredIf(function () {
        return this.enImageSrc == null;
      }),
      fileSizeValidation
    },
    fil_image: {
      fileSizeValidation
    }
  },
  watch: {
    en_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.enImageSrc = value;
            })
            .catch(() => {
              this.enImageSrc = null;
            });
        } else {
          this.enImageSrc = null;
        }
      }
    },
    fil_image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.filImageSrc = value;
            })
            .catch(() => {
              this.filImageSrc = null;
            });
        } else {
          this.filImageSrc = null;
        }
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    removeEnImage() {
      this.en_image = null;
      this.en_image_url = "";
      this.enImageName = "";
      this.enImageSrc = null;
    },
    removeFilImage() {
      this.fil_image = null;
      this.fil_image_url = "";
      this.filImageName = "";
      this.filImageSrc = null;
    },
    onSelectEn(evt) {
      if(evt.target.files.length > 0){
        this.enImageName = evt.target.files[0].name;
        // this.file = file;
      }else{
        return
      }
    },
    onSelectFil(evt) {
      if(evt.target.files.length > 0){
        this.filImageName = evt.target.files[0].name;
      }else{
        return
      }
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.confirmSubmit();
      }
    },
    proceed() {
      let url = config.cmsPromotionBannerAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        audit_by: this.$store.getters.loginId,
        en_title: this.en_title,
        en_body: this.en_body,
        en_image_url: this.en_image_url,
        fil_title: this.fil_title,
        fil_body: this.fil_body,
        fil_image_url: this.fil_image_url,
        default_order: this.default_order,
        item_order: this.default_order == false ? this.item_order : null,
        category: this.category
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$emit("clicked");
                this.$refs.addPromotionBanner.hide();
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
                this.$emit("failed", "add_promotion_banner", this.feedback.status);
                this.$refs.addPromotionBanner.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    async uploadEnImage() {
      if (this.enImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.en_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            // console.log(response)
            this.loading = false;
            if (response.data.file.filename) {
              this.en_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async uploadFilImage() {
      if (this.filImageName == "")
        return;

      const formData = new FormData();
      formData.append("file", this.fil_image);
      this.loading = true;
      try {
        await this.$http
          .post(config.uploadImageUrl, formData)
          .then(function(response) {
            this.loading = false;
            if (response.data.file.filename) {
              this.fil_image_url = response.data.file.filename;
            }
            // this.proceed();
          });
      } catch (err) {
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
      }
    },
    async confirmSubmit() {
      const p1 = this.uploadEnImage();
      const p2 = this.uploadFilImage();
      const someResult = await p1;
      const anotherResult = await p2;

      this.proceed();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.default_order = true;
      this.item_order = 0;
      this.en_title = "<h5></h5>";
      this.en_body = "";
      this.en_image = null;
      this.fil_title = "<h5></h5>";
      this.fil_body = "";
      this.fil_image = null;
      this.category = "ALL";
      $("#addPromotionBanner").find('.modal-content').first().removeAttr('tabindex');
    }
  }
};
</script>
